export default {
  page: {
    component: import('@/views/integrations/protokol/timber/Index.vue'),
    permissions: ['view']
  }
}
